import { useTranslation } from 'react-i18next';

export function FormatBoolean(value: boolean | string) {
  const { t } = useTranslation('i18n');
  if (!value || value === 'false') return t('No');
  return t('Yes');
}
